import { TOURNAMENT_FIDE_GAME_RESULT, TOURNAMENT_GAME_RESULT, } from "../../constants";
import { formatDate } from "../../utils/date-helper";
import { getScoreBeforeGame } from "../utils/gameUtils";
import { isPlayerInRound } from "../utils/playerUtils";
import { TournamentOrganizerFacade } from "./TournamentOrganizerFacade";
class PairingServiceBase {
    generateRoundData(round, players, games) {
        const roundPlayers = players.map((p) => ({
            ...p,
            isParticipating: isPlayerInRound(p, round.roundNumber),
            scoreBeforeGame: getScoreBeforeGame(p.username, round),
        }));
        const roundGames = games.filter((g) => g.roundNumber < round.roundNumber);
        return [roundPlayers, roundGames];
    }
}
export class SwissPairingService extends PairingServiceBase {
    bbpPairingsExecutor;
    constructor(bbpPairingsExecutor) {
        super();
        this.bbpPairingsExecutor = bbpPairingsExecutor;
    }
    async generatePairings(tournament, round, players, games) {
        if (players.every((p) => !p.active))
            return [];
        const roundNumber = round.roundNumber;
        const [roundPlayers, roundGames] = this.generateRoundData(round, players, games);
        const trfbxData = this.toTRFBXData(tournament, roundPlayers, roundGames, roundNumber);
        const bbpPairs = await this.bbpPairingsExecutor(trfbxData);
        if (!bbpPairs)
            return [];
        return bbpPairs.map((pair) => ({
            whiteUsername: players.find((p) => p.startingRank === Number(pair[0]))?.username ??
                null,
            blackUsername: players.find((p) => p.startingRank === Number(pair[1]))?.username ??
                null,
        }));
    }
    toTRFBXData(tournament, players, games, roundNumber) {
        console.log("toTRFBXData", roundNumber);
        return {
            system: "dutch",
            tournament: {
                name: tournament.name,
                city: "Chesssquad Academy",
                federation: "Chesssquad Academy",
                startDate: formatDate(tournament.startTime, "DD/MM/YYYY"),
                endDate: tournament.finishTime
                    ? formatDate(tournament.finishTime, "DD/MM/YYYY")
                    : null,
                numberOfPlayers: players.length,
                numberOfRatedPlayers: 0,
                numberOfTeams: 0,
                typeOfTournament: "Individual: Swiss System",
                chiefArbiter: "Chesssquad Academy",
                deputyChiefArbiter: "Chesssquad Academy",
                allottedTimesPerMovesOrGame: "moves/time, increment",
                numberOfRounds: tournament.totalRounds,
                scoring: {
                    win: 1.0,
                    draw: 0.5,
                    lose: 0,
                    zeroBye: 0,
                    paringBye: 1,
                    forfeitLoss: 0,
                },
            },
            players: players
                .map((p, i) => {
                return {
                    ...p,
                    currentRank: i + 1,
                };
            })
                .sort((a, b) => a.startingRank - b.startingRank)
                .map((p) => {
                const sexIndex = p.user.dna?.indexOf("male") ?? -1;
                const roundGames = [];
                for (let i = 0; i < tournament.currentRound; i++) {
                    const roundNumber = i + 1;
                    const roundStarted = games.some((g) => g.roundNumber === roundNumber);
                    if (!roundStarted) {
                        continue;
                    }
                    const roundGame = games.find((g) => g.roundNumber === roundNumber &&
                        (g.whiteUsername === p.username ||
                            g.blackUsername === p.username));
                    roundGames.push(roundGame); // null equals unparticipated
                }
                return {
                    dataIdentificationNumber: "001",
                    startingRank: p.startingRank,
                    sex: sexIndex >= 0 ? "m" : "w",
                    name: p.user.name ?? `${p.user.first_name}`,
                    points: p.scoreBeforeGame,
                    currentRank: p.currentRank,
                    active: p.active && p.isParticipating,
                    rounds: roundGames.map((g) => {
                        if (!g) {
                            return {
                                opponentStartingRank: undefined,
                                color: "-",
                                result: TOURNAMENT_FIDE_GAME_RESULT[TOURNAMENT_GAME_RESULT.DISQUALIFIED],
                            };
                        }
                        const opp = players.find((p1) => g.whiteUsername === p.username
                            ? p1.username === g.blackUsername
                            : p1.username === g.whiteUsername);
                        const currResult = p.username === g.whiteUsername ? g.whiteResult : g.blackResult;
                        return {
                            opponentStartingRank: opp ? opp.startingRank : undefined,
                            color: opp ? (p.username === g.whiteUsername ? "w" : "b") : "-",
                            result: TOURNAMENT_FIDE_GAME_RESULT[currResult],
                        };
                    }),
                };
            }),
        };
    }
}
export class TournamentOrganizerPairingService extends PairingServiceBase {
    facade;
    constructor() {
        super();
        this.facade = new TournamentOrganizerFacade();
    }
    async generatePairings(tournament, round, players, games) {
        if (players.every((p) => !p.active))
            return [];
        const roundNumber = round.roundNumber;
        const [roundPlayers, roundGames] = this.generateRoundData(round, players, games);
        this.facade.initialize(tournament, roundGames, roundPlayers);
        if (tournament.type === "Elim") {
            this.facade.enterElimResults(games);
        }
        return this.facade.getPairings(roundNumber);
    }
}
